module.exports = __webpack_public_path__ + "img/approvals.2e37da9e.svg";